(function(){
  "use strict";

  const DEFAULTS = {
    brand: "Cloudy",
    productName: "Playera",
    buttonText: "Guía de tallas",
    accentColor: "rgb(138, 84, 195)",
    sizeChart: [
      { size: "XS", widthCM: 48, lengthCM: 57 },
      { size: "S",  widthCM: 50, lengthCM: 59 },
      { size: "M",  widthCM: 52, lengthCM: 61 },
      { size: "L",  widthCM: 54, lengthCM: 63 }
    ],
    fitOptions: [
      { id: "ajustada", name: "Ajustada" },
      { id: "normal",   name: "Normal", checked: true },
      { id: "floja",    name: "Floja" }
    ],
    strings: {
      guideTitle: "Guía de tallas",
      step1Note: "La edad influye en la distribución de tu peso, conocer tu edad nos permite recomendarte la talla correcta.",
      step2Header: "Preferencia de uso",
      step2Title: "¿Cómo te gusta usar las playeras?",
      step3Header: "Tu talla",
      step3Subtitle: "🎉 Encontramos tu medida perfecta",
      close: "Cerrar",
      chartTitle: "Tabla de tallas",
      columnSize: "Talla",
      columnWidth: "Ancho",
      columnLength: "Largo"
    }
  };

let CURRENT = { ...DEFAULTS };
let STATE = {
  currentStep: 1,
  gender: "female",      // ⬅️ Cambio aquí
  height: 165,           // ⬅️ Cambio aquí
  weight: 60,            // ⬅️ Cambio aquí (en kg)
  age: 25,
  heightUnit: 'cm',
  weightUnit: 'lbs',
  fit: "normal",
  recommendedSize: null
};

  const CSS = () => `
    :root { 
      --pgts-accent: ${CURRENT.accentColor}; 
      --pgts-field-h: 44px; 
      --pgts-unit-w: 156px; 
      --pgts-seg-pad: 4px; 
    }
    
    .pgts-hidden { display: none !important; }
    
    .pgts-overlay { 
      position: fixed; 
      inset: 0; 
      background: rgba(0,0,0,.55); 
      z-index: 2147483002; 
      display: flex; 
      align-items: center; 
      justify-content: center; 
    }
    
    .pgts-dialog { 
      width: 100%; 
      max-width: 560px; 
      background: #fff; 
      color: #111827; 
      display: flex; 
      flex-direction: column;
      border-radius: 16px;
      max-height: 90vh;
      overflow: hidden;
    }

    /* Header */
    .pgts-header { 
      display: grid; 
      grid-template-columns: 1fr auto 1fr; 
      align-items: center; 
      padding: 16px 20px 8px; 
    }
    
    .pgts-title { 
      grid-column: 2; 
      text-align: center; 
      font: 700 18px/1.2 system-ui, -apple-system, Segoe UI, Roboto, Inter, Arial, sans-serif; 
      color: #111; 
    }
    
    .pgts-close-btn { 
      grid-column: 3; 
      justify-self: end; 
      border: 0; 
      background: linear-gradient(135deg, #E0CCF5, #D4B5F0); /* ⬅️ CAMBIO AQUÍ */
      cursor: pointer; 
      width: 36px; 
      height: 36px; 
      font-size: 28px; 
      color: #111; 
      border-radius: 50%;
      transition: all 0.2s;
      display: flex;
      align-items: center;
      justify-content: center;
      line-height: 1;
    }

    .pgts-close-btn:hover {
      background: linear-gradient(135deg, #D4B5F0, rgb(138, 84, 195)); /* ⬅️ CAMBIO AQUÍ */
      transform: scale(1.05);
    }
    
    .pgts-progress { 
      height: 3px; 
      background: #eceef1; 
      margin: 8px 20px 0; 
      border-radius: 999px; 
      overflow: hidden; 
    }
    
    .pgts-progress > span { 
      display: block; 
      height: 100%; 
      width: 0; 
      background: rgb(138, 84, 195); /* ⬅️ CAMBIO AQUÍ */
      transition: width .28s ease; 
    }

/* Body sin logo de fondo */
.pgts-body { 
  padding: 20px 20px 16px; 
  display: flex; 
  flex-direction: column; 
  gap: 16px; 
  flex: 1; 
  overflow-y: auto;
  position: relative;
  background: #fff; /* ⬅️ Solo fondo blanco */
}

.pgts-step { 
  display: grid; 
  gap: 16px; 
  align-content: start;
  position: relative;
  z-index: 1;
}
    
    .pgts-step { 
      display: grid; 
      gap: 16px; 
      align-content: start;
      position: relative;
      z-index: 1;
    }
    
    .pgts-caption { 
      font: 400 13px/1.45 system-ui, -apple-system, Segoe UI, Roboto, Inter, Arial, sans-serif; 
      color: #6b7280; 
      letter-spacing: .02em;
      margin-top: 4px;
    }

    /* Field blocks */
    .pgts-block {
      display: grid;
      gap: 8px;
    }
    
    .pgts-line { 
      display: grid; 
      grid-template-columns: 1fr var(--pgts-unit-w); 
      align-items: flex-end;
      gap: 20px; 
    }
    
    .pgts-label { 
      font: 500 13px/1.1 system-ui, -apple-system, Segoe UI, Roboto, Inter, Arial, sans-serif; 
      color: #68707a; 
      letter-spacing: .02em; 
      margin-bottom: 8px;
    }
    
    .pgts-field { 
      position: relative; 
      display: flex; 
      align-items: center; 
      background: #f3f4f6; 
      border: 0; 
      border-radius: 12px; 
      padding: 0 12px;
      height: var(--pgts-field-h);
      cursor: pointer;
      transition: background 0.2s;
    }
    
    .pgts-field:hover {
      background: #e8eaed;
    }
    
    /* Select styling */
    .pgts-field.select::after { 
      content: ""; 
      position: absolute; 
      right: 12px; 
      top: 50%; 
      width: 8px; 
      height: 8px; 
      border: 2px solid #9aa0a6; 
      border-left: 0; 
      border-top: 0; 
      transform: translateY(-60%) rotate(45deg); 
      pointer-events: none; 
    }
    
    .pgts-select { 
      width: 100%; 
      border: 0; 
      background: transparent; 
      padding: 0 24px 0 0; 
      font: 600 16px/1.1 system-ui, -apple-system, Segoe UI, Roboto, Inter, Arial, sans-serif; 
      color: #111; 
      appearance: none; 
      outline: none;
      cursor: pointer;
      height: 100%;
    }

    /* Unit toggles */
    .pgts-seg { 
      position: relative; 
      display: flex; 
      align-items: center; 
      justify-content: space-between; 
      background: #f1f2f4; 
      border-radius: 12px; 
      padding: var(--pgts-seg-pad); 
      border: 1px solid #e5e7eb; 
      height: var(--pgts-field-h); 
      width: var(--pgts-unit-w); 
      box-sizing: border-box;
    }
    
    .pgts-seg-pill { 
      position: absolute; 
      top: var(--pgts-seg-pad); 
      bottom: var(--pgts-seg-pad); 
      left: var(--pgts-seg-pad); 
      width: calc(50% - var(--pgts-seg-pad)); 
      background: #fff; 
      border-radius: 8px; 
      border: 1px solid #e6e8eb; 
      box-shadow: 0 1px 2px rgba(0,0,0,.08); 
      transition: transform .22s ease; 
    }
    
    .pgts-seg[data-pos="right"] .pgts-seg-pill { 
      transform: translateX(100%); 
    }
    
    .pgts-seg button { 
      position: relative; 
      z-index: 1; 
      border: 0; 
      background: transparent; 
      flex: 1 0 50%; 
      height: 100%; 
      border-radius: 8px; 
      font: 700 14px/1 system-ui, -apple-system, Segoe UI, Roboto, Inter, Arial, sans-serif; 
      color: #6b7280; 
      cursor: pointer;
      transition: color 0.2s;
    }
    
    .pgts-seg button.on { 
      color: #111; 
    }

    /* Step 2 - más espaciado */
    .pgts-title-sm { 
      font: 600 16px/1.3 system-ui, -apple-system, Segoe UI, Roboto, Inter, Arial, sans-serif; 
      color: #111; 
      letter-spacing: .01em;
      margin-top: 20px;
      margin-bottom: 16px;
    }
    
    .pgts-options { 
      display: grid; 
      gap: 12px;
      margin-top: 20px;
    }
    
    .pgts-opt { 
      padding: 14px 16px; 
      border-radius: 12px; 
      border: 2px solid #e5e7eb; 
      background: #fff; 
      cursor: pointer; 
      font: 600 16px system-ui, -apple-system, Segoe UI, Roboto, Inter, Arial, sans-serif; 
      color: #111;
      transition: all 0.2s;
    }
    
    .pgts-opt:hover {
      border-color: #d1d5db;
      background: #fafafa;
    }
    
    .pgts-opt[aria-checked="true"] { 
      background: #f3ebff; /* ⬅️ CAMBIO AQUÍ - lila muy suave */
      border-color: rgb(138, 84, 195); /* ⬅️ CAMBIO AQUÍ */
    }

    /* Footer simple con fondo lila SIN Luffy */
    .pgts-footer { 
      padding: 16px 20px 20px;
      border-top: 1px solid #eef1f4;
      background: linear-gradient(135deg, #E0CCF5, #D4B5F0); /* ⬅️ CAMBIO AQUÍ */
      display: grid;
      gap: 10px;
      position: relative;
    }
    
    .pgts-btn { 
      appearance: none; 
      border: 0; 
      border-radius: 999px; 
      padding: 14px 18px; 
      cursor: pointer; 
      font: 700 16px system-ui, -apple-system, Segoe UI, Roboto, Inter, Arial, sans-serif; 
      color: #fff; 
      background: rgb(138, 84, 195); /* ⬅️ CAMBIO AQUÍ */
      transition: all 0.2s;
    }
    
    .pgts-btn:hover {
      background: rgb(118, 64, 165); /* ⬅️ CAMBIO AQUÍ - un tono más oscuro */
      opacity: 1;
    }
    
    .pgts-btn.secondary { 
      background: #fff; 
      color: #111; 
      border: 1px solid #d1d5db; 
    }
    
    .pgts-btn.secondary:hover {
      background: #f9fafb;
      opacity: 1;
    }

    /* Step 3 - More compact */
    .pgts-final { 
      text-align: center; 
      padding: 8px 0;
    }
    
    .pgts-final .pgts-subtitle {
      font: 500 13px system-ui, -apple-system, Segoe UI, Roboto, Inter, Arial, sans-serif;
      color: #6b7280;
      margin-bottom: 4px;
    }
    
    .pgts-final .pgts-size { 
      font: 800 36px/1 system-ui, -apple-system, Segoe UI, Roboto, Inter, Arial, sans-serif; 
      color: var(--pgts-accent);
      margin: 8px 0 12px;
    }
    
    .pgts-summary { 
      display: grid; 
      grid-template-columns: 1fr 1fr; 
      gap: 4px 12px;
      font: 500 13px/1.2 system-ui, -apple-system, Segoe UI, Roboto, Inter, Arial, sans-serif; 
      color: #111;
      max-width: 280px;
      margin: 0 auto;
    }

    .pgts-table { 
      width: 100%; 
      border-collapse: separate; 
      border-spacing: 0; 
      font: 500 13px system-ui, -apple-system, Segoe UI, Roboto, Inter, Arial, sans-serif;
      margin-top: 24px;
    }
    
    .pgts-table th { 
      color: #6b7280; 
      text-transform: uppercase; 
      font-weight: 700; 
      font-size: 11px; 
      text-align: left; 
      padding: 6px 6px;
    }
    
    .pgts-table td { 
      padding: 7px 6px; 
      border-top: 1px solid #f1f2f4;
    }

    @media (max-width: 600px) {
      .pgts-dialog {
        max-width: 100%;
        height: 100%;
        max-height: 100%;
        border-radius: 0;
      }
    }
  `;

  // Conversion functions
  const kgToLbs = kg => kg * 2.20462;
  const lbsToKg = lbs => lbs / 2.20462;
  const cmToIn = cm => cm / 2.54;
  const inToCm = inch => inch * 2.54;

  function buildTable() {
    const rows = CURRENT.sizeChart
      .map(r => `<tr><td><strong>${r.size}</strong></td><td>${r.lengthCM} cm</td><td>${r.widthCM} cm</td></tr>`)
      .join("");
    return `
      <div>
        <h3 style="text-align:center; font:700 14px system-ui; margin: 0 0 8px">${CURRENT.strings.chartTitle}</h3>
        <table class="pgts-table" aria-label="${CURRENT.strings.chartTitle}">
          <thead><tr><th>${CURRENT.strings.columnSize}</th><th>${CURRENT.strings.columnLength}</th><th>${CURRENT.strings.columnWidth}</th></tr></thead>
          <tbody>${rows}</tbody>
        </table>
      </div>`;
  }

  function heightOptions(unit) {
    const opts = [];
    if (unit === 'cm') {
      for (let v = 90; v <= 220; v++) {
        opts.push({ v, label: `${v} cm` });
      }
    } else {
      // Corrección: 90cm = 35.4in, 220cm = 86.6in
      for (let v = 35; v <= 87; v++) {
        opts.push({ v, label: `${v} in` });
      }
    }
    return opts;
  }

  function weightOptions(unit) {
    const opts = [];
    if (unit === 'lbs') {
      for (let v = 55; v <= 300; v++) {
        opts.push({ v, label: `${v} lbs` });
      }
    } else {
      const s = Math.round(lbsToKg(55));
      const e = Math.round(lbsToKg(300));
      for (let v = s; v <= e; v++) {
        opts.push({ v, label: `${v} kg` });
      }
    }
    return opts;
  }

  function ageOptions() {
    const a = [];
    for (let v = 8; v <= 99; v++) {
      a.push({ v, label: String(v) });
    }
    return a;
  }

  function fillSelect(sel, items, selectedValue) {
    sel.innerHTML = items.map(o => `<option value="${o.v}">${o.label}</option>`).join("");
    if (selectedValue != null) {
      sel.value = String(selectedValue);
    }
    if (sel.selectedIndex === -1) {
      sel.selectedIndex = 0;
    }
  }

  function template() {
    return `
      <div class="pgts-overlay pgts-hidden" data-pgts="overlay" role="dialog" aria-modal="true">
        <div class="pgts-dialog" role="document">
          <div class="pgts-header">
            <div class="pgts-title" data-pgts="title">${CURRENT.strings.guideTitle}</div>
            <button class="pgts-close-btn" data-pgts="close" aria-label="${CURRENT.strings.close}">×</button>
          </div>
          <div class="pgts-progress"><span data-pgts="progress"></span></div>

          <div class="pgts-body">
            <!-- Step 1 -->
            <div class="pgts-step" data-pgts="step-1">
              <div class="pgts-block">
                <div class="pgts-label">Sexo</div>
                <div class="pgts-field select">
                  <select class="pgts-select" data-pgts="gender">
                    <option value="male">Hombre</option>
                    <option value="female">Mujer</option>
                  </select>
                </div>
              </div>

              <div class="pgts-line">
                <div class="pgts-block">
                  <div class="pgts-label">Altura</div>
                  <div class="pgts-field select">
                    <select class="pgts-select" data-pgts="height-select"></select>
                  </div>
                </div>
                <div class="pgts-seg" data-pgts="height-unit" data-pos="left">
                  <span class="pgts-seg-pill" aria-hidden="true"></span>
                  <button type="button" class="on" data-val="cm">cm</button>
                  <button type="button" data-val="in">in</button>
                </div>
              </div>

              <div class="pgts-line">
                <div class="pgts-block">
                  <div class="pgts-label">Peso</div>
                  <div class="pgts-field select">
                    <select class="pgts-select" data-pgts="weight-select"></select>
                  </div>
                </div>
                <div class="pgts-seg" data-pgts="weight-unit" data-pos="left">
                  <span class="pgts-seg-pill" aria-hidden="true"></span>
                  <button type="button" class="on" data-val="lbs">lbs</button>
                  <button type="button" data-val="kg">kg</button>
                </div>
              </div>

              <div class="pgts-block">
                <div class="pgts-label">Edad</div>
                <div class="pgts-field select">
                  <select class="pgts-select" data-pgts="age-select"></select>
                </div>
              </div>

              <p class="pgts-caption">${CURRENT.strings.step1Note}</p>
            </div>

            <!-- Step 2 -->
            <div class="pgts-step pgts-hidden" data-pgts="step-2">
              <div class="pgts-title-sm">🤔 ${CURRENT.strings.step2Title}</div>
              <div class="pgts-options" data-pgts="fitopts">
                ${CURRENT.fitOptions.map(o => `
                  <div class="pgts-opt" role="radio" aria-checked="${o.checked ? 'true' : 'false'}" data-val="${o.id}">${o.name}</div>
                `).join('')}
              </div>
            </div>

            <!-- Step 3 -->
            <div class="pgts-step pgts-hidden" data-pgts="step-3">
              <div class="pgts-final">
                <div class="pgts-subtitle">${CURRENT.strings.step3Subtitle}</div>
                <div style="font:500 13px system-ui;color:#6b7280">Tu talla es</div>
                <div class="pgts-size" data-pgts="final">…</div>
                <div class="pgts-summary" data-pgts="summary"></div>
              </div>
              ${buildTable()}
            </div>
          </div>

          <div class="pgts-footer" data-pgts="footer">
            <button class="pgts-btn" data-pgts="next">Continuar</button>
            <button class="pgts-btn secondary pgts-hidden" data-pgts="back">Regresar</button>
          </div>
        </div>
      </div>`;
  }

  function clamp(n, min, max) {
    return Math.min(max, Math.max(min, n));
  }

  function estimateChestCm({ sex, height, weight, age }) {
    const base = sex === 'male' ? 95 : 84;
    const weightCoef = sex === 'male' ? 0.9 : 1.1;
    const dW = (weight - (sex === 'male' ? 70 : 60)) * weightCoef;  // ⬅️ IMPORTANTE
    const heightCoef = sex === 'male' ? 0.25 : 0.18;
    const dH = (height - (sex === 'male' ? 175 : 165)) * heightCoef; // ⬅️ IMPORTANTE
    
    let dA = 0;
    if (age >= 30) {
      dA = Math.min(5, (age - 30) * 0.1);
    } else if (age <= 20) {
      dA = Math.max(-3, (age - 20) * 0.1);
    }
    
    const minChest = sex === 'male' ? 78 : 75;
    const maxChest = sex === 'male' ? 125 : 115;
    
    return clamp(base + dW + dH + dA, minChest, maxChest);
  }

  function easeForFit(fit) {
    // Holguras más generosas para mujeres
    if (fit === 'ajustada') return 6;  // Era 4
    if (fit === 'floja') return 14;    // Era 12
    return 10;                          // Era 8 (normal)
  }

  function pickSizeByAnthro(state) {
    const bodyChest = estimateChestCm({
      sex: state.gender,
      height: state.height,
      weight: state.weight,
      age: state.age
    });
    const need = bodyChest + easeForFit(state.fit);
    const rows = CURRENT.sizeChart.map(r => ({ size: r.size, circ: r.widthCM * 2 }));
    let idx = rows.findIndex(x => x.circ >= need);
    if (idx === -1) idx = rows.length - 1;
    if (state.fit === 'floja' && idx < rows.length - 1 && rows[idx].circ - need < 4) idx += 1;
    return rows[idx].size;
  }

  let __y = 0;
  function lock() {
    __y = window.scrollY || document.documentElement.scrollTop || 0;
    const b = document.body;
    b.style.position = 'fixed';
    b.style.top = `-${__y}px`;
    b.style.left = '0';
    b.style.right = '0';
    b.style.width = '100%';
  }

  function unlock() {
    const b = document.body;
    const y = Math.abs(parseInt(b.style.top || '0', 10)) || 0;
    b.style.position = '';
    b.style.top = '';
    b.style.left = '';
    b.style.right = '';
    b.style.width = '';
    window.scrollTo(0, y);
  }

  function syncSeg(seg, value) {
    seg.setAttribute('data-pos', (value === 'cm' || value === 'lbs') ? 'left' : 'right');
    seg.querySelectorAll('button').forEach(b => {
      b.classList.toggle('on', b.dataset.val === value);
    });
  }

  function init() {
    // Check if already initialized
    if (document.querySelector('[data-pgts-root]')) return;

    // Add styles
    const st = document.createElement('style');
    st.id = 'pgts-style';
    st.textContent = CSS();
    document.head.appendChild(st);

    // Add HTML
    const wrap = document.createElement('div');
    wrap.dataset.pgtsRoot = 'true';
    wrap.innerHTML = template();
    document.body.appendChild(wrap);

    // Get elements
    const overlay = wrap.querySelector('[data-pgts="overlay"]');
    const titleEl = wrap.querySelector('[data-pgts="title"]');
    const progress = wrap.querySelector('[data-pgts="progress"]');
    
    const gSel = wrap.querySelector('[data-pgts="gender"]');
    const hSel = wrap.querySelector('[data-pgts="height-select"]');
    const wSel = wrap.querySelector('[data-pgts="weight-select"]');
    const aSel = wrap.querySelector('[data-pgts="age-select"]');
    
    const hSeg = wrap.querySelector('[data-pgts="height-unit"]');
    const wSeg = wrap.querySelector('[data-pgts="weight-unit"]');
    
    const nextBtn = wrap.querySelector('[data-pgts="next"]');
    const backBtn = wrap.querySelector('[data-pgts="back"]');
    const closeBtn = wrap.querySelector('[data-pgts="close"]');
    
    const fitBox = wrap.querySelector('[data-pgts="fitopts"]');
    const finalEl = wrap.querySelector('[data-pgts="final"]');
    const sumEl = wrap.querySelector('[data-pgts="summary"]');

    const headerTitles = [
      null,
      CURRENT.strings.guideTitle,
      CURRENT.strings.step2Header,
      CURRENT.strings.step3Header
    ];

    function showStep(n) {
      STATE.currentStep = n;
      wrap.querySelectorAll('.pgts-step').forEach(el => el.classList.add('pgts-hidden'));
      wrap.querySelector(`[data-pgts="step-${n}"]`).classList.remove('pgts-hidden');
      progress.style.width = (n === 1 ? 0 : (n === 2 ? 50 : 100)) + '%';
      titleEl.textContent = headerTitles[n] || CURRENT.strings.guideTitle;
      
      if (n === 1) {
        backBtn.classList.add('pgts-hidden');
      } else {
        backBtn.classList.remove('pgts-hidden');
      }
      
      nextBtn.textContent = n === 3 ? 'Cerrar' : 'Continuar';
    }

    function open() {
      overlay.classList.remove('pgts-hidden');
      overlay.style.display = 'flex';
      lock();
      
      // Initialize selects
      fillSelect(hSel, heightOptions(STATE.heightUnit), 
        STATE.heightUnit === 'cm' ? STATE.height : Math.round(cmToIn(STATE.height)));
      fillSelect(wSel, weightOptions(STATE.weightUnit), 
        STATE.weightUnit === 'lbs' ? Math.round(kgToLbs(STATE.weight)) : STATE.weight);
      fillSelect(aSel, ageOptions(), STATE.age);
      
      gSel.value = STATE.gender;
      syncSeg(hSeg, STATE.heightUnit);
      syncSeg(wSeg, STATE.weightUnit);
      showStep(1);
    }

    function close() {
      overlay.style.display = 'none';
      overlay.classList.add('pgts-hidden');
      unlock();
      showStep(1);
    }

    // Expose the open function globally
    window.openGuiaDeTallas = open;

    // Event listeners
    closeBtn.addEventListener('click', close);
    overlay.addEventListener('click', e => {
      if (e.target === overlay) close();
    });
    
    document.addEventListener('keydown', e => {
      if (e.key === 'Escape' && !overlay.classList.contains('pgts-hidden')) {
        close();
      }
    });

    // Select change handlers
    gSel.addEventListener('change', () => {
      STATE.gender = gSel.value;
    });
    
    hSel.addEventListener('change', () => {
      const v = parseInt(hSel.value, 10);
      if (STATE.heightUnit === 'cm') {
        STATE.height = v;
      } else {
        STATE.height = Math.round(inToCm(v));
      }
    });
    
    wSel.addEventListener('change', () => {
      const v = parseInt(wSel.value, 10);
      if (STATE.weightUnit === 'kg') {
        STATE.weight = v;
      } else {
        STATE.weight = Math.round(lbsToKg(v));
      }
    });
    
    aSel.addEventListener('change', () => {
      const v = parseInt(aSel.value, 10);
      if (!isNaN(v)) STATE.age = v;
    });

    // Unit toggles
    hSeg.addEventListener('click', (e) => {
      const btn = e.target.closest('button');
      if (!btn) return;
      STATE.heightUnit = btn.dataset.val;
      syncSeg(hSeg, STATE.heightUnit);
      const selected = STATE.heightUnit === 'cm' ? STATE.height : Math.round(cmToIn(STATE.height));
      fillSelect(hSel, heightOptions(STATE.heightUnit), selected);
    });
    
    wSeg.addEventListener('click', (e) => {
      const btn = e.target.closest('button');
      if (!btn) return;
      STATE.weightUnit = btn.dataset.val;
      syncSeg(wSeg, STATE.weightUnit);
      const selected = STATE.weightUnit === 'lbs' ? Math.round(kgToLbs(STATE.weight)) : STATE.weight;
      fillSelect(wSel, weightOptions(STATE.weightUnit), selected);
    });

    // Fit selection
    fitBox.addEventListener('click', e => {
      const it = e.target.closest('.pgts-opt');
      if (!it) return;
      fitBox.querySelectorAll('.pgts-opt').forEach(x => x.setAttribute('aria-checked', 'false'));
      it.setAttribute('aria-checked', 'true');
      STATE.fit = it.getAttribute('data-val');
    });

    // Navigation buttons
    nextBtn.addEventListener('click', () => {
      if (STATE.currentStep === 1) {
        showStep(2);
      } else if (STATE.currentStep === 2) {
        STATE.recommendedSize = pickSizeByAnthro(STATE);
        finalEl.textContent = STATE.recommendedSize;
        
        const fitName = (CURRENT.fitOptions.find(f => f.id === STATE.fit) || {}).name || STATE.fit;
        const sexName = STATE.gender === 'male' ? 'Hombre' : 'Mujer';
        
        // Mostrar valores en las unidades seleccionadas por el usuario
        let heightDisplay, weightDisplay;
        
        if (STATE.heightUnit === 'cm') {
          heightDisplay = `${STATE.height} cm`;
        } else {
          heightDisplay = `${Math.round(cmToIn(STATE.height))} in`;
        }
        
        if (STATE.weightUnit === 'kg') {
          weightDisplay = `${STATE.weight} kg`;
        } else {
          weightDisplay = `${Math.round(kgToLbs(STATE.weight))} lbs`;
        }
        
        sumEl.innerHTML = `
          <div><b>Altura:</b> ${heightDisplay}</div>
          <div><b>Peso:</b> ${weightDisplay}</div>
          <div><b>Sexo:</b> ${sexName}</div>
          <div><b>Corte:</b> ${fitName}</div>`;
        showStep(3);
      } else {
        close();
      }
    });

    backBtn.addEventListener('click', () => {
      if (STATE.currentStep === 3) showStep(2);
      else if (STATE.currentStep === 2) showStep(1);
    });
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();